import { Navigate, useSearchParams } from 'react-router-dom'

/**
 * Redirect `/configs?type=<t>&config=<id>` → `/configure?type=<t>&id=<id>`.
 * Preserves any `run=` param. Falls back to `/configure` when `type` is
 * missing.
 */
export function ConfigsRedirect() {
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type')
  const config = searchParams.get('config')
  const run = searchParams.get('run')
  if (!type) return <Navigate to="/configure" replace />
  const params = new URLSearchParams({ type })
  if (config) params.set('id', config)
  if (run) params.set('run', run)
  return <Navigate to={`/configure?${params.toString()}`} replace />
}
